import axios from "axios";
import { Base_URL } from "../url";

export const fetchDistricts = async () => {
  try {
    const response = await axios.get(`${Base_URL}/DistrictMaster/GetAllDistricts`);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching districts!";
  }
};

export const downloadDistrictsExcel = async () => {
  try {
    const response = await axios.post(
      `${Base_URL}/DistrictMaster/DownloadDistrictsExcel`,
      null, // Empty body for POST request
      {
        responseType: 'blob',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        }
      }
    );
    return response;
  } catch (error) {
    throw error.response?.data || "Error downloading districts data!";
  }
};